<script>
import HelpIcon from './Shared/HelpIcon.vue';
import ReactiveMarker from './Shared/ReactiveMarker.vue';
import SelectAllMarker from './Shared/SelectAllMarker.vue';

/**
 * The DataTable component.
 *
 * Provides functionality to check/uncheck all rows.
 */
export default {
  components: {
    HelpIcon,
    ReactiveMarker,
    SelectAllMarker
  },
  props: {
    ids: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selected: []
    };
  },
  computed: {
    allChecked() {
      return this.selected.length === this.ids.length;
    }
  },
  watch: {
    selected() {
      this.$emit('update:selected', this.selected);
    }
  },
  methods: {
    checkAll() {
      this.selected = !this.allChecked ? this.ids.slice() : [];
    }
  }
};
</script>
